import { store } from '@/app/shared/stores';

class CachedPackagesServiceClass {
  constructor() {
    async function updateIfNeeded() {
      const thirtyMinutesInSeconds = 1800;
      const sameUser = store.state.packages.lastMemberGuid === store.state.user.userGuid;
      if (
        !sameUser
        || store.state.packages.lastFetch === undefined
        || (new Date() - new Date(store.state.packages.lastFetch)) / 1000 > thirtyMinutesInSeconds
      ) {
        await store.dispatch('updatePackages');
      }
    }

    this.getMembershipPackages = async () => {
      await updateIfNeeded();
      return store.state.packages.packages.MembershipPackages;
    };

    this.getFlexiPackages = async () => {
      await updateIfNeeded();
      return store.state.packages.packages.AwayPackages;
    };

    this.getHomePackages = async () => {
      await updateIfNeeded();
      return store.state.packages.packages.HomePackages;
    };

    this.getTopupPackages = async () => {
      await updateIfNeeded();
      return [
        ...store.state.packages.packages.AwayPackages,
        ...store.state.packages.packages.HomePackages,
      ];
    };

    this.getExperiencePackages = async () => {
      await updateIfNeeded();
      return store.state.packages.packages.ExperiencePackages;
    };

    this.getLessonPackages = async () => {
      await updateIfNeeded();
      return store.state.packages.packages.LessonPackages;
    };
  }
}

const CachedPackagesService = new CachedPackagesServiceClass();

export { CachedPackagesService };
